<template>
  <div>
    <div
      v-if="!loading && commercialisationGraineSelected"
      class="d-flex flex-column"
    >
      <div
        v-if="quantiteContratsTotal > 0"
        class="d-flex justify-space-between"
        :class="$vuetify.breakpoint.mobile ? 'mb-1' : ''"
      >
        <div
          class="texte-gris-fonce align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'mention' : 'texte'"
        >
          Mes contrats livrés
        </div>
        <div
          class="secondary--text d-flex"
          :class="$vuetify.breakpoint.mobile ? 'mention' : 'intro'"
        >
          <div class="d-flex">
            <div class="align-self-center">
              Reste à livrer
            </div>
            <div class="pl-1 pl-md-2 align-self-center">
              {{ affichagePoids(quantiteContratsALivrer) }}
            </div>
          </div>
          <v-icon
            v-if="quantiteContratsALivrer > 0"
            class="ml-1 secondary--text align-self-center"
            :class="$vuetify.breakpoint.mobile ? 'mention' : 'intro'"
            @click="updateFiltreEtatLogistique()"
          >
            mdi-chevron-right
          </v-icon>
        </div>
      </div>
      <BaseBarHorizontalChartCommercialisation
        v-if="quantiteContratsTotal > 0"
        :chart-data="chartDataContrats"
      />
      <v-divider
        v-if="quantiteLivraisonTotal > 0 && quantiteContratsTotal > 0"
        class="my-3 pb-4"
      />
      <div
        v-if="quantiteLivraisonTotal > 0"
        class="d-flex justify-space-between"
        :class="$vuetify.breakpoint.mobile ? 'mb-1' : ''"
      >
        <div
          class="texte-gris-fonce align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'mention' : 'texte'"
        >
          Mes livraisons vendues
        </div>
        <div
          class=" primary--text d-flex"
          :class="$vuetify.breakpoint.mobile ? 'mention' : 'intro'"
        >
          <div class="d-flex">
            <div class="align-self-center">
              Reste à vendre
            </div> 
            <div class="pl-1 pl-md-2 align-self-center">
              {{ affichagePoids(quantiteLivraisonAVendre) }}
            </div>
            <v-tooltip
              v-if="quantiteResteAVendreDepotventeBleFou && !$vuetify.breakpoint.mobile && !$vuetify.breakpoint.tablet"
              top
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  :size="$vuetify.breakpoint.mobile ? 18 : 20"
                  color="primary"
                  class="pl-1"
                  v-on="on"
                  @click="isOpenResteAVendreBau = true"
                >
                  mdi-information
                </v-icon>
              </template>
              <span>Dont {{ affichagePoids(quantiteResteAVendreDepotventeBleFou) }} de blé fourrager</span>
            </v-tooltip>
            <v-icon
              v-if="quantiteResteAVendreDepotventeBleFou && ($vuetify.breakpoint.mobile || $vuetify.breakpoint.tablet)"
              :size="$vuetify.breakpoint.mobile ? 18 : 20"
              color="primary"
              class="pl-1"
              @click="isOpenResteAVendreBau = true"
            >
              mdi-information
            </v-icon>
          </div>
          <v-icon
            v-if="quantiteLivraisonAVendre > 0"
            :class="$vuetify.breakpoint.mobile ? 'mention' : 'intro'"
            color="primary"
            @click="updateFiltreApport()"
          >
            mdi-chevron-right
          </v-icon>
        </div>
      </div>
      <BaseBarHorizontalChartCommercialisation
        v-if="quantiteLivraisonTotal > 0"
        :chart-data="chartDataLivraisons"
      />
      <div
        v-if="quantiteTresoMoissonTotal > 0"
        class="d-flex justify-space-between"
        :class="$vuetify.breakpoint.mobile ? 'mb-1' : ''"
      >
        <div
          class="texte-gris-fonce align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'mention' : 'texte'"
        >
          Dont tréso moisson
        </div>
        <div
          class="texte-jaune d-flex"
          :class="$vuetify.breakpoint.mobile ? 'mention' : 'intro'"
        >
          <div class="d-flex">
            <div class="align-self-center">
              Reste à fixer
            </div>
            <div class="pl-1 pl-md-2 align-self-center">
              {{ affichagePoids(quantiteTresoMoissonAFixer) }}
            </div> 
          </div>
          <v-tooltip
            v-if="quantiteResteAVendreTresoMoissonBleFou && !$vuetify.breakpoint.mobile && !$vuetify.breakpoint.tablet"
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon
                :size="$vuetify.breakpoint.mobile ? 18 : 20"
                color="#DBBD00"
                class="pl-1"
                @click="isOpenResteAVendreTMBau = true"
                v-on="on"
              >
                mdi-information
              </v-icon>
            </template>
            <span>Dont {{ affichagePoidsTooltip(quantiteResteAVendreTresoMoissonBleFou) }} de blé fourrager</span>
          </v-tooltip>
          <v-icon
            v-if="quantiteResteAVendreTresoMoissonBleFou && ($vuetify.breakpoint.mobile || $vuetify.breakpoint.tablet)"
            :size="$vuetify.breakpoint.mobile ? 18 : 20"
            color="#DBBD00"
            class="pl-1"
            @click="isOpenResteAVendreTMBau = true"
          >
            mdi-information
          </v-icon>
          <v-icon
            v-if="quantiteTresoMoissonAFixer > 0"
            color="#DBBD00"
            class="ml-1"
            :class="$vuetify.breakpoint.mobile ? 'mention' : 'intro'"
            @click="updateFiltreTypeContrat"
          >
            mdi-chevron-right
          </v-icon>
        </div>
      </div>
      <BaseBarHorizontalChartCommercialisation
        v-if="quantiteTresoMoissonTotal > 0"
        :chart-data="chartDataTresoMoisson"
      />
      <v-divider
        v-if="quantiteStockTotal > 0"
        class="my-3 pb-4"
      />
      <div
        v-if="quantiteStockTotal > 0"
        class="d-flex justify-space-between"
        :class="$vuetify.breakpoint.mobile ? 'mb-1' : ''"
      >
        <div
          class="texte-gris-fonce align-self-center"
          :class="$vuetify.breakpoint.mobile ? 'mention' : 'texte'"
        >
          Mes stocks
        </div>
        <div
          class="texte-orange-fonce d-flex"
          :class="$vuetify.breakpoint.mobile ? 'mention' : 'intro'"
        >
          <div class="d-flex">
            <div class="align-self-center">
              Reste à reprendre
            </div>
            <div class="pl-1 pl-md-2 align-self-center">
              {{ affichagePoids(quantiteStockAReprendre) }}
            </div>
          </div>
        </div>
      </div>
      <BaseBarHorizontalChartCommercialisation
        v-if="quantiteStockTotal > 0"
        :chart-data="chartDataStocks"
      />

      <v-snackbar
        v-if="$vuetify.breakpoint.mobile || $vuetify.breakpoint.tablet"
        v-model="isOpenResteAVendreBau"
        color="primary"
      >
        <span class="texte white--text">Dont {{ affichagePoidsTooltip(quantiteResteAVendreDepotventeBleFou) }} de blé fourrager</span>
      </v-snackbar>
      <v-snackbar
        v-if="$vuetify.breakpoint.mobile || $vuetify.breakpoint.tablet"
        v-model="isOpenResteAVendreTMBau"
        color="#DBBD00"
      >
        <span class="texte">Dont {{ affichagePoidsTooltip(quantiteResteAVendreTresoMoissonBleFou) }} de blé fourrager</span>
      </v-snackbar>
    </div>
    <div
      v-if="commercialisationGraineSelected === null && !loading"
    >
      <div
        class="d-flex
        align-center
        flex-column"
        :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
      >
        <img
          src="@/assets/no-commercialisation.svg"
          alt="no-commercialisation"
        >
        <div
          class="intro texte-gris-fonce text-align-center mt-2"
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
        >
          <span>Suivez l'état des lieux de votre commercialisation et de vos stocks de grains auprès d'Agrial</span>
        </div>
      </div>
    </div>
    <BaseLoader v-if="loading" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { sommeDesNombresDefinis } from '@/utils/math'
import { round, sum } from 'lodash'
import BaseBarHorizontalChartCommercialisation from '@/components/chart/base-bar-horizontal-chart-commercialisation.vue'
import BaseLoader from '@/components/common/base-loader.vue'

export default {
  name: 'Commercialisation',
  components: {BaseBarHorizontalChartCommercialisation, BaseLoader},
  data () {
    return {
      erreur: false,
      loading: false,
      isOpenResteAVendreBau: false,
      isOpenResteAVendreTMBau: false,
      borderRadius: 10,
      borderRadiusAllCorners: {topLeft: 10, topRight: 10, bottomLeft: 10, bottomRight: 10}
    }
  },
  computed: {
    ...mapGetters({
      listeCommercialisationGraineRs3: 'commercialisation/listeCommercialisationGraineRs3',
      filtresContratValeursPossible: 'filtresContrat/filtresValeursPossibles',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive'
    }),

    commercialisationGraineSelected () {
      return this.codeGraineActive!= null ? this.listeCommercialisationGraineRs3.find(commercialisation => commercialisation.codeIdaRs3 === this.codeGraineActive) : null
    },
    quantiteDepotVenteEnAttente () {
      return this.commercialisationGraineSelected != null ? sum(this.commercialisationGraineSelected.commercialisationGrainesRs1.map(c=>c.quantiteDepotVenteEnAttenteEnKg != null ? c.quantiteDepotVenteEnAttenteEnKg : 0)) : 0
    },
    quantiteEnAttenteTotale () {
      return this.commercialisationGraineSelected != null ? this.commercialisationGraineSelected.quantiteEnAttenteEnKg != null ? this.commercialisationGraineSelected.quantiteEnAttenteEnKg - this.quantiteTresoMoissonEnAttente + this.quantiteDepotVenteEnAttente : 0 : 0
    },

    // CONTRATS LIVRES
    quantiteContratsLivre () {
      return this.commercialisationGraineSelected != null ? Number(sommeDesNombresDefinis(
        this.commercialisationGraineSelected.quantiteLivreeSurContratEnKg,
        this.commercialisationGraineSelected.quantiteVendueSansContratEnKg,
        this.commercialisationGraineSelected.quantiteLivreeEchangeSemenceEnKg,
        this.commercialisationGraineSelected.quantiteLivreeEchangeAlimentEnKg)
      ) : 0
    },
    quantiteContratsTotal () {
      return this.commercialisationGraineSelected != null ? Number(sommeDesNombresDefinis(
        this.commercialisationGraineSelected.quantiteContractualiseeEnKg,
        this.commercialisationGraineSelected.quantiteVendueSansContratEnKg,
        this.commercialisationGraineSelected.quantiteContractualiseeEchangeSemenceEnKg,
        this.commercialisationGraineSelected.quantiteContractualiseeEchangeAlimentEnKg,
        this.quantiteTresoMoissonEnAttente)) : 0
    },
    quantiteContratsALivrer () {
      return this.commercialisationGraineSelected != null ? Number(sommeDesNombresDefinis(
        this.commercialisationGraineSelected.quantiteContractualiseeEnKg,
        this.commercialisationGraineSelected.quantiteContractualiseeEchangeSemenceEnKg,
        this.commercialisationGraineSelected.quantiteContractualiseeEchangeAlimentEnKg,
        -this.commercialisationGraineSelected.quantiteLivreeSurContratEnKg,
        -this.commercialisationGraineSelected.quantiteLivreeEchangeSemenceEnKg,
        -this.commercialisationGraineSelected.quantiteLivreeEchangeAlimentEnKg)) : 0
    },
    pourcentageContratsLivre () {
      return this.quantiteContratsTotal != null && this.quantiteContratsTotal > 0 ? Math.floor(this.quantiteContratsLivre / this.quantiteContratsTotal * 100) : 0
    },
    chartDataContrats () {
      let datasets = []
      if (this.pourcentageContratsLivre > 0) {
        datasets.push({
          type: 'bar',
          backgroundColor: '#01713C',
          label : 'Contrats livrés : ' + this.affichagePoidsTooltip(this.quantiteContratsLivre),
          data: [this.pourcentageContratsLivre],
          barThickness: 22,
          inflateAmount: 6,
          borderRadius: this.borderRadiusAllCorners,
          borderSkipped: false
        })
      }
      if (100 - this.pourcentageContratsLivre > 0) {
        datasets.push({
          type: 'bar',
          backgroundColor: '#F1F2F5',
          label : 'Contrats à livrer : ' + this.affichagePoidsTooltip(this.quantiteContratsALivrer),
          data: [100 - this.pourcentageContratsLivre],
          barThickness: 22,
          inflateAmount: 6,
          borderRadius: this.borderRadius,
          borderSkipped: this.pourcentageContratsLivre === 0 ? false : 'left'
        })
      }
      return {
        id: 'chartDataContrats',
        labels: [''],
        datasets: datasets
      }
    },

    // LIVRAISONS VENDUES
    quantiteLivraisonAVendre () {
      return this.quantiteLivraisonTotal - this.quantiteLivraisonVendu
    },
    quantiteLivraisonVendu () {
      return this.commercialisationGraineSelected != null ? Number(sommeDesNombresDefinis(
        this.commercialisationGraineSelected.quantiteLivreeSurContratEnKg,
        this.commercialisationGraineSelected.quantiteVendueSansContratEnKg,
        this.commercialisationGraineSelected.quantiteLivreeEchangeSemenceEnKg,
        this.commercialisationGraineSelected.quantiteLivreeEchangeAlimentEnKg,
        -this.quantiteTresoMoissonEngageeAFixer)
        ) : 0
    },
    quantiteLivraisonTotal () {
      return this.commercialisationGraineSelected != null ? Number(sommeDesNombresDefinis(
        this.commercialisationGraineSelected.quantiteLivreeEnKg,
        -this.commercialisationGraineSelected.quantiteStockReprisEnKg,
        -this.commercialisationGraineSelected.quantiteStockAReprendreEnKg)
        ) : 0
    },
    pourcentageLivraisonsVendu () {
      return this.quantiteLivraisonTotal != null && this.quantiteLivraisonTotal > 0 ? Math.floor(this.quantiteLivraisonVendu / this.quantiteLivraisonTotal * 100) : 0
    },
    chartDataLivraisons () {
      let datasets = []
      if (this.pourcentageLivraisonsVendu > 0) {
        datasets.push({
          type: 'bar',
          backgroundColor: '#969A27',
          label : 'Livraisons vendues : ' + this.affichagePoidsTooltip(this.quantiteLivraisonVendu),
          data: [this.pourcentageLivraisonsVendu],
          borderRadius: this.borderRadiusAllCorners,
          borderSkipped: false,
          barThickness: 22,
          inflateAmount: 6
        })
      }
      if (100 - this.pourcentageLivraisonsVendu > 0) {
        datasets.push({
          type: 'bar',
          backgroundColor: '#F1F2F5',
          label : 'Livraisons à vendre : ' + this.affichagePoidsTooltip(this.quantiteLivraisonAVendre),
          data: [100 - this.pourcentageLivraisonsVendu],
          borderRadius: this.borderRadiusAllCorners,
          borderSkipped: this.pourcentageLivraisonsVendu === 0 ? false : 'left',
          barThickness: 22,
          inflateAmount: 6
        })
      }
      return {
        id: 'chartDataLivraison',
        labels: [''],
        datasets: datasets
      }
    },

    //TRESO MOISSON
    quantiteTresoMoissonLivreeSansFixation () {
        return this.commercialisationGraineSelected != null ? sum(this.commercialisationGraineSelected.commercialisationGrainesRs1.map(c=>c.quantiteTresoMoissonLivreeSansFixationEnKg != null ? c.quantiteTresoMoissonLivreeSansFixationEnKg : 0)) : 0
    },
    quantiteTresoMoissonEngageeAFixer () {
      return this.commercialisationGraineSelected != null ? sum(this.commercialisationGraineSelected.commercialisationGrainesRs1.map(c => c.quantiteTresoMoissonEngageeAFixerEnKg != null ? c.quantiteTresoMoissonEngageeAFixerEnKg : 0)) : 0
},
    quantiteTresoMoissonEnAttente () {
      return this.commercialisationGraineSelected != null ? sum(this.commercialisationGraineSelected.commercialisationGrainesRs1.map(c=>c.quantiteTresoMoissonEnAttenteEnKg != null ? c.quantiteTresoMoissonEnAttenteEnKg : 0)) : 0
    },
    quantiteTresoMoissonResteALivrerFixer () {
      return this.commercialisationGraineSelected != null ? sum(this.commercialisationGraineSelected.commercialisationGrainesRs1.map(c=>c.quantiteTresoMoissonResteALivrerFixerEnKg != null ? c.quantiteTresoMoissonResteALivrerFixerEnKg : 0)) : 0
    },
    quantiteTresoMoissonFixer () { 
      return this.commercialisationGraineSelected != null ? Number(sum(this.commercialisationGraineSelected.commercialisationGrainesRs1.map(c => c.quantiteTresoMoissonFixerEnKg != null ? c.quantiteTresoMoissonFixerEnKg : 0))) : 0
    },
    quantiteTresoMoissonAFixer () {
      return Number(sommeDesNombresDefinis(
       this.quantiteTresoMoissonLivreeSansFixation,
        + this.quantiteTresoMoissonEngageeAFixer,
        - this.quantiteTresoMoissonEnAttente
        - this.quantiteTresoMoissonResteALivrerFixer))
    },
    quantiteTresoMoissonTotal () {
      return this.quantiteTresoMoissonAFixer + this.quantiteTresoMoissonFixer
    },
    quantiteLivreeTresoMoisson () {
      return this.commercialisationGraineSelected != null ? sum(this.commercialisationGraineSelected.commercialisationGrainesRs1.map(c=>c.quantiteLivreeTresoMoissonEnKg != null ? c.quantiteLivreeTresoMoissonEnKg : 0)) : 0
    },
    pourcentageTresoMoisson () {
      return this.quantiteTresoMoissonTotal!= null && this.quantiteTresoMoissonTotal > 0 ? Math.floor(this.quantiteTresoMoissonFixer / this.quantiteTresoMoissonTotal * 100 ) : 0
    },
    chartDataTresoMoisson () {
      let datasets = []
      if (this.pourcentageTresoMoisson > 0) {
        datasets.push({
          type: 'bar',
            backgroundColor: '#DBBD00',
            label : 'Tréso moisson fixé : ' + this.affichagePoidsTooltip(this.quantiteTresoMoissonFixer),
            data: [this.pourcentageTresoMoisson],
            borderRadius: this.borderRadiusAllCorners,
            borderSkipped: false,
            barThickness: 22,
            inflateAmount: 6
        })
      }
      if (100 - this.pourcentageTresoMoisson > 0) {
        datasets.push({
          type: 'bar',
            backgroundColor: '#F1F2F5',
            label : 'Tréso moisson à fixer : ' + this.affichagePoidsTooltip(this.quantiteTresoMoissonAFixer),
            data: [100 - this.pourcentageTresoMoisson],
            borderRadius: this.borderRadius,
            borderSkipped: this.pourcentageTresoMoisson === 0 ? false : 'left',
            barThickness: 22,
            inflateAmount: 6
        })
      }
      return {
        id: 'chartDataTresoMoisson',
        labels: [''],
        datasets: datasets
      }
    },

     //STOCKS
    quantiteStockAReprendre () {
       return this.commercialisationGraineSelected != null ? Number(
         this.commercialisationGraineSelected.quantiteStockAReprendreEnKg) || 0 : 0
    },
    quantiteStockRepris () {
      return this.commercialisationGraineSelected != null ? Number(
        this.commercialisationGraineSelected.quantiteStockReprisEnKg) || 0 : 0
    },
    quantiteStockTotal () {
      return this.commercialisationGraineSelected != null ? Number(sommeDesNombresDefinis(
          this.commercialisationGraineSelected.quantiteStockReprisEnKg,
          this.commercialisationGraineSelected.quantiteStockAReprendreEnKg)) : 0
    },
    pourcentageStockRepris () {
      return this.quantiteStockTotal != null && this.quantiteStockTotal > 0 ? Math.floor(this.quantiteStockRepris / this.quantiteStockTotal * 100) : 0
    },
    chartDataStocks () {
      let datasets = []
      if (this.pourcentageStockRepris > 0) {
        datasets.push({
          type: 'bar',
          backgroundColor: '#EC6608',
          label : 'Stocks repris : ' + this.affichagePoidsTooltip(this.quantiteStockRepris),
          data: [this.pourcentageStockRepris],
          borderRadius: this.borderRadiusAllCorners,
          borderSkipped: false,
          barThickness: 22,
          inflateAmount: 6
        })
      }
      if (100 - this.pourcentageStockRepris > 0) {
        datasets.push({
          type: 'bar',
          backgroundColor: '#F1F2F5',
          label : 'Stocks à reprendre : ' + this.affichagePoidsTooltip(this.quantiteStockAReprendre),
          data: [100 - this.pourcentageStockRepris],
          borderRadius: this.borderRadius,
          borderSkipped: this.pourcentageStockRepris === 0 ? false : 'left',
          barThickness: 22,
          inflateAmount: 6
        })
      }
      return {
        id: 'chartDataStocks',
        labels: [''],
        datasets: datasets
      }
    },

    quantiteResteAVendreDepotventeBleFou () {
      let result = null
      if (this.codeGraineActive === 'BT' && this.commercialisationGraineSelected) {
        const comRs1BleBAU = this.commercialisationGraineSelected.commercialisationGrainesRs1.find(c => c.codeIdaRs1 === 'BLEFOU')

        if (comRs1BleBAU) {
          const quantiteBleBAUDepotVente = comRs1BleBAU.quantiteDepotVenteVendueSansContratEnKg || 0
          const quantiteBleBAU = quantiteBleBAUDepotVente

          const quantiteBleBAUDepotVenteEnAttente = comRs1BleBAU.quantiteDepotVenteEnAttenteEnKg || 0
          const quantiteBleBAUEnAttente = quantiteBleBAUDepotVenteEnAttente

          result = quantiteBleBAU - quantiteBleBAUEnAttente
        }
      }
      return Math.round(result != null ? result / 1000 : 0 )
    },
    quantiteResteAVendreTresoMoissonBleFou () {
      let result = null
      if (this.codeGraineActive === 'BT' && this.commercialisationGraineSelected) {
        const comRs1BleBAU = this.commercialisationGraineSelected.commercialisationGrainesRs1.find(c => c.codeIdaRs1 === 'BLEFOU')

        if (comRs1BleBAU) {
          const quantiteBleBAUTresoMoisson = comRs1BleBAU.quantiteTresoMoissonLivreeSansFixationEnKg || 0
          const quantiteBleBAU = quantiteBleBAUTresoMoisson

          const quantiteBleBAUTresoMoissonEnAttente = comRs1BleBAU.quantiteTresoMoissonEnAttenteEnKg || 0
          const quantiteBleBAUEnAttente = quantiteBleBAUTresoMoissonEnAttente

          result = quantiteBleBAU - quantiteBleBAUEnAttente
        }
      }
      return Math.round(result != null ? result / 1000 : 0)
    },
  },
  watch: {
    codeGraineActive: {
      handler (annee) {
        if (annee) {
          this.loadCommercialisation()
        }
      },
      immediate: true
    },
    anneeRecolteActive () {
      this.loadCommercialisation()
    }
  },

  methods: {
    ...mapActions({
      fetchCommercialisation: 'commercialisation/fetchCommercialisation',
      setValeursCategoriesContrats: 'filtresContrat/setValeursCategoriesContrats',
      setValeursNumerosContrats: 'filtresContrat/setValeursNumerosContrats',
      setValeursEtatsPaiements: 'filtresContrat/setValeursEtatsPaiements',
      setFiltresContrats: 'filtresContrat/setFiltres',
      setFiltresApports: 'filtresApports/setFiltres'
    }),
    loadCommercialisation () {
      this.loading = true
      this.fetchCommercialisation()
        .catch(() => {
          this.erreur = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    affichagePoids (quantite) {
      let result
      if (quantite === 0) {
        result = 0 + ' t'
      } else if (quantite > -1000 && quantite < 1000) {
        result = round(quantite * 0.001, 3) + ' t'
      } else {
        result = round(quantite * 0.001, 0) + ' t'
      }
      return result
    },
    affichagePoidsTooltip (quantite) {
      let result
      if (quantite === 0) {
        result = 0 + ' t'
      } else {
        result = round(quantite * 0.001, 3) + ' t'
      }
      return result
    },
    updateFiltreEtatLogistique () {
      if(this.quantiteContratsALivrer > 0) {
        const filtresAUpdate = {
          categorieContrat: this.filtresContratValeursPossible.categoriesContrats[0],
          numeroContrat: this.filtresContratValeursPossible.numerosContrats[0],
          etatLogistique: [{code:'EN_COURS_LIVRAISON', libelle:'en cours de livraison'}, {code:'A_LIVRER', libelle:'à livrer'}],
          etatPaiement: this.filtresContratValeursPossible.etatsPaiements[0]
        }
        this.setFiltresContrats(filtresAUpdate)
          .then(() => this.$router.push({name: 'main.mes-contrats'}))
      }
    },
    updateFiltreTypeContrat () {
      if(this.quantiteTresoMoissonAFixer > 0) {
        const filtresAUpdate = {
          categorieContrat: 'Prix ferme',
          numeroContrat: 'Sans contrat',
          etatLogistique: [{code:'TOUS', libelle:'Tous'}],
          etatPaiement: this.filtresContratValeursPossible.etatsPaiements[0]
        }      
        this.setFiltresContrats(filtresAUpdate)
          .then(() => this.$router.push({name: 'main.mes-contrats'}))
      }
    },
    updateFiltreApport () {
      if (this.quantiteLivraisonAVendre > 0) {
        const filtresAUpdate = { 
          numerosBonsApport: 'Tous',
          typesContratApport: 'Tous',
          numerosContratsApport: 'Sans contrat',
          moisApport: 'Tous',
          grainesValorisees: 'Tous'                
        }
        this.setFiltresApports(filtresAUpdate)
          .then(() =>this.$router.push({ name: 'main.mes-recoltes', params:{
            anneeRecolte: this.anneeRecolteSelected,
            codeGraineRs3: this.codeGraineRs3Selected        
          }}))
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.text-align-center {
  text-align: center;
}
</style>